<template>
  <div>
    <!-- <b>Please implement vendor-specific AfterSales component in the 'components/Order' directory</b> -->
    <SfProperty v-if="!isButton" :name="$t('After_sales')" class="sf-property--full-width property">
      <template #value>
        {{ $t(order.status) }}
        <SfButton class="sf-button--text" @click="applyOrderAfter" v-if="order.status != 'ORDER_REFUNDED'">
          <span v-if="order.status != 'ORDER_AFTER_SALE'">{{
            $t('After_sales_apply')
            }}</span>
          <span v-else>{{ $t('After_sales_form') }}</span>
        </SfButton>
      </template>
    </SfProperty>
    <SfButton v-if="isButton" class="sf-button--text" @click="applyOrderAfter">
      <span v-if="order.status != 'ORDER_AFTER_SALE'">{{
        $t('After_sales_apply')
        }}</span>
      <span v-else>{{ $t('After_sales_form') }}</span>
    </SfButton>
    <!-- <SfModal v-if="false" :title="$t('crate after sales')" transitionModal="sf-fade" transitionOverlay="sf-fade" :visible="visible"
      cross overlay :persistent="true" @close="closeModal" class="modalShouHou">
      <template #default>
        <form class="afterForm">
          <div v-if="afterOrder && afterOrder.orderItem.length && false" class="itemList">
            <SfCollectedProduct v-for="(item, i) in afterOrder.orderItem" :key="i" :image="item.imgUrl"
              :imageWidth="140" :imageHeight="200" :title="item.title" :regularPrice="item.price" specialPrice=""
              :qty="item.num" :minQty="0" :maxQty="item.num" v-model="item.num" @click:remove="removeItem(i)">
              <template #configuration>
                <div></div>
              </template>
            </SfCollectedProduct>
          </div>
          <div>
            <SfInput :value="form.reason" :label="$t('after_sales_Reason')" name="reason" type="text"
              :icon="{ icon: '', color: '', size: '' }" valid :required="false" :disabled="false"
              :hasShowPassword="false" placeholder="" v-model="form.reason" />
          </div>
          <div>
            <SfButton type="button" @click="saveShouHou">{{
              $t('After_sales_save')
              }}</SfButton>
          </div>
        </form>
      </template>
    </SfModal> -->
    <confirmModal
        ref="afterModal"
        @close="closeModal"
        :showFooter="false"
        class="aflterModal"
      >
      <form class="afterForm" slot="context">
        <div>
          <div v-if="afterOrder && afterOrder.orderItem.length && false" class="itemList">
            <SfCollectedProduct v-for="(item, i) in afterOrder.orderItem" :key="i" :image="item.imgUrl"
              :imageWidth="140" :imageHeight="200" :title="item.title" :regularPrice="item.price" specialPrice=""
              :qty="item.num" :minQty="0" :maxQty="item.num" v-model="item.num" @click:remove="removeItem(i)">
              <template #configuration>
                <div></div>
              </template>
            </SfCollectedProduct>
          </div>
           <div style="margin-left: 5px; margin-top: 2rem;">
            <SfTextarea :value="form.reason" :label="$t('after_sales_Reason')" name="review_content" type="text"
              :icon="{ icon: '', color: '', size: '' }" valid :required="false"
              :disabled="false" :hasShowPassword="false" placeholder="" v-model="form.reason" />
          </div>
        </div>
        <!-- <div>
          <SfButton type="button" @click="saveReview">{{
            $t('save_order_review')
          }}</SfButton>
        </div> -->
      </form>
      <div slot="footer" style="text-align:center;display: flex; justify-content: end;">
        <sf-button class="mini-btn" @click="closeModal"
          style="margin:1rem;background:#fff;color:#000;border:1px solid #dee0e3;margin-right:0;">
          {{ $t('cancel') }}
        </sf-button>
        <SfButton class="mini-btn"  @click="saveShouHou" style="margin:1rem;margin-right: 0;">
          {{ $t('Save')}}
        </SfButton>
      </div>
    </confirmModal>
  </div>
</template>

<script>
import { ref, computed } from '@nuxtjs/composition-api';
import {
  SfButton,
  SfProperty,
  SfLink,
  SfCollectedProduct,
  SfInput,
  SfModal,
  SfTextarea
} from '@storefront-ui/vue';
import { useShouHou, orderGetters, useOrder, useOrderAfterSalesApply } from '@bee-hole/coms';
import confirmModal from '~/components/ContentModal/confirm';
// import {onSSR} from '@vue-storefront/core';
export default {
  name: 'AfterSales',
  props: {
    order: {
      type: Object,
      default: {}
    },
    isRefund: {
      type: Boolean,
      default: false
    },
    isButton: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SfButton,
    SfProperty,
    SfLink,
    SfCollectedProduct,
    SfInput,
    SfModal,
    confirmModal,
    SfTextarea
  },
  setup(props, {emit, root}) {
    const visible = ref(false);
    const afterOrder = ref(JSON.parse(JSON.stringify(props.order)));
    const { refundRes, apply, aftersales, afterRes } = useShouHou(afterOrder.value.orderId);
    const { afterSaleApply, result: applyRes } = useOrderAfterSalesApply();
    const afterModal = ref();
    const skuInfo = computed(() => {
      return orderGetters.getShouHouSkuInfo(afterOrder?.value?.orderItem);
    });
    const isButton = computed(() => {
      return props.isButton;
    });
    const form = ref({
      reason: '',
      sku_info: skuInfo.value,
      order_id: afterOrder.value.orderId
    });

    const applyOrderAfter = async () => {
      visible.value = true;
      afterModal.value.setModal({
        title: root.$t('crate_after_sales'),
        showFooter: false
      });
    };

    const removeItem = async (i) => {
      afterOrder.value.orderItem.splice(i, 1);
    };

    const saveShouHou = async () => {
      // console.log('form', form.value, props.order);
      try {
        form.value.order_id = props.order.orderId;
        if (props.order.status !== 'ORDER_WAIT_PAYMENT' && props.order.status !== 'ORDER_AFTER_SALE') {
          await afterSaleApply(form.value);
          // await apply({ order_id: afterOrder.value.orderId });
          if (applyRes.value.status === 'ORDER_AFTER_SALE') {
            emit('applyOk');
            visible.value = false;
          }
        } else {
          emit('applyOk');
          await afterSaleApply(form.value);
          visible.value = false;
        }
      } catch (ee) {
        console.log('e', ee);
      }
    };
    const closeModal = () => {
      visible.value = false;
      afterModal.value?.close();
    };
    return {
      applyOrderAfter,
      afterOrder,
      removeItem,
      form,
      saveShouHou,
      visible,
      closeModal,
      afterRes,
      afterModal,
      isButton
    };
  }
};
</script>
<style lang="scss" scoped>
.itemList {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.afterForm {
  width: 100%;
}

@media only screen and (max-width: 1024px) {
  .modalShouHou {
    --modal-width: 100vw;
    --modal-left: 100vw;
    --modal-top: 0px;
  }
}

@media only screen and (min-width: 1024px) {
  .modalShouHou {
    --modal-width: 65rem;
    --modal-left: 20%;
    --modal-transform: translate3d(-15%, -20%, 0);
    --modal-top: 10%;
  }
}
</style>
<style lang="scss" >
@media only screen and (max-width: 1024px) {
  .modalShouHou {
    >.sf-modal__container {
      z-index: 999999999999;
      margin-top: 0;
    }
  }
}

@media only screen and (min-width: 1024px) {
  .modalShouHou {
    >.sf-modal__container {
      z-index: 999999999999;
      margin-top: 20px;
    }
  }
}
.aflterModal{
 @include for-desktop{
   --modal-width: 60vw;
  --modal-top: 20rem;
  --modal-max-height: 610px;
  .sf-textarea textarea {
      width: 95%;
      margin-top:0.5rem;
  }
  .sf-modal__container{
    max-width: 850px;
  }
 }
 @include for-mobile{
  --modal-width: 80vw;
  --modal-height: 35vh;;
  --modal-top: 5%;
  .sf-textarea textarea {
      width: 85%;
      margin-top:0.5rem;
  }
 }
 .sf-textarea__label{
   margin-bottom: 0.5rem;
 }
}
</style>
